export const DEFAULT_DEBIT_BANK_ACCOUNT_NOT_CONFIGURED = 'default_debit_bank_account_not_configured';
